export interface IParcelAssessment {
    PID: string;
    AAN: string;
    Year: number;
    Value: number;
    Acres: number;
    PercentChange: number;
}

export class ParcelAssessment implements IParcelAssessment {
    public PID = '';
    public AAN = '';
    public Year = -1;
    public Value = -1;
    public Acres = -1;
    public PercentChange = -1;
    constructor(
        assessmentObject: any,
    ) {
        this.PID = assessmentObject.pid;
        this.AAN = assessmentObject.aan;
        this.Year = assessmentObject.year;
        this.Value = assessmentObject.value;
        this.Acres = assessmentObject.acres;
        this.PercentChange = assessmentObject.percentChange;
    }
}

